module.exports = __webpack_public_path__ + "static/media/320x100.2568cec1.png";